export const PRIORITY_DEADLINE = 'Wednesday, December 30th, 2026';
export const REGULAR_DEADLINE = 'Sunday, March 21st, 2027';
export const ORIENTATION_DATE = 'Saturday, May 22nd, 2027';
export const PRE_SCLA_DATE = 'Saturday, May 29th, June 5th, June 12th';
export const CAMP_DATE = 'Tuesday, June 15th - Thursday, June 17th';
export const PROGRAM_DATES = 'Monday, June 14th - Saturday, August 7th, 2027';
export const SCLA_PROGRAM_YEAR = '2027';
